import { USER_ROLES } from "./user";

export const SUBSCRIPTION_BILLING_PERIOD_TYPE = {
  MONTHLY: "monthly_plans",
  QUARTERLY: "quarterly_plans",
  ANNUAL: "annual_plans",
} as const;
export const SUBSCRIBE_USING_CRYPTO_PAGE_ROUTE = "/subscribe-crypto";
export const SUBSCRIPTION_COMPARISON_ROUTE = "/plan-comparison";
export const SUBSCRIPTION_BILLING_PERIOD = {
  MONTHLY: "monthly",
  QUARTERLY: "quarterly",
  ANNUAL: "annual",
};

export const SUBSCRIPTION_CARD_BUTTON_LABEL = {
  FREE: "Continue With Free",
  PAID: "Subscribe",
};

export const COUNTRY_SPECFIC_SUBSCRIPTION_MESSAGES = {
  //RU: {
  //  LABEL: "Мы теперь поддерживаем банковские карты (Мир, Visa, Mastercard) и оплату через Сбербанк для российских пользователей!",
  //  SUB_LABEL: "Только разовые платежи — вам нужно будет оформлять подписку каждый месяц заново.",
  //},
  IN: {
    LABEL: "We support UPI payments in India for an easy and secure way to upgrade. Payments do not renew automatically ",
    SUB_LABEL: "",
  },
  KR: {
    LABEL: "한국 사용자를 위해 카카오페이 결제를 지원합니다!",
    SUB_LABEL: "쉽고 빠른 방법으로 프리미엄 기능을 이용해보세요.",
  },
  HK: {
    LABEL: "我們在香港支持支付寶付款，讓您輕鬆安全地升級",
    SUB_LABEL: "付款不會自動續訂",
  },
  CN: {
    LABEL: "我们支持支付宝付款，让您轻松安全地升级",
    SUB_LABEL: "付款不会自动续订",
  },
};

export const POPULAR_PLAN = USER_ROLES.BASIC;

export const BASE_PAYMENT_METHOD_CLASS = "bg-content2 dark:bg-content1";
